export const ERROR_MESSAGES = {
  name: 'COMMON.APPLICATION.ERROR_MESSAGES.NAME',
  cpf: 'COMMON.APPLICATION.ERROR_MESSAGES.CPF',
  email: 'COMMON.APPLICATION.ERROR_MESSAGES.EMAIL',
  emailConfirmation: 'COMMON.APPLICATION.ERROR_MESSAGES.EMAIL_CONFIRMATION',
  accepted: 'COMMON.APPLICATION.ERROR_MESSAGES.PRIVACY_POLICY',
  generic: 'COMMON.APPLICATION.ERROR_MESSAGES.GENERIC',
};

export const FIELDS_PROPERTIES = {
  email: {
    label: 'COMMON.APPLICATION.LABEL.EMAIL',
    type: 'email',
    validations: {
      required: ERROR_MESSAGES.email,
      email: ERROR_MESSAGES.email,
    },
  },

  emailConfirmation: {
    type: 'email',
    label: 'COMMON.APPLICATION.LABEL.EMAIL_CONFIRMATION',
    validations: {
      required: ERROR_MESSAGES.email,
      email: ERROR_MESSAGES.email,
      equalsTo: {
        errorMsg: ERROR_MESSAGES.emailConfirmation,
        params: { target: 'email' },
      },
    },
  },

  name: {
    type: 'text',
    label: 'COMMON.APPLICATION.LABEL.NAME',
    validations: {
      required: ERROR_MESSAGES.name,
      personName: ERROR_MESSAGES.name,
    },
  },

  cpf: {
    type: 'tel',
    label: 'COMMON.APPLICATION.LABEL.CPF',
    validations: {
      required: ERROR_MESSAGES.cpf,
      cpf: ERROR_MESSAGES.cpf,
    },
  },
};
